import { Box, Divider } from "@origin-digital/ods-core";
import { Skeleton } from "@origin-digital/ods-lab";

export const SearchResultItemSkeleton = ({
  dataId,
}: {
  dataId: string;
}): JSX.Element => (
  <Box>
    <Box
      display="flex"
      flexDirection="row"
      alignItems="flex-start"
      gap="small"
      data-id={dataId}
      marginBottom="medium"
      marginTop="large"
      marginLeft="xlarge"
    >
      <Box paddingTop="xxsmall">
        <Skeleton
          variant="rectangular"
          width={20}
          height={20}
          backgroundColor="light"
        />
      </Box>
      <Box width="full">
        <Box marginBottom="xsmall">
          <Skeleton
            variant="rectangular"
            width="30%"
            height={20}
            backgroundColor="light"
          />
        </Box>
        <Box marginBottom="xsmall">
          <Skeleton
            variant="rectangular"
            width="45%"
            height={20}
            backgroundColor="light"
          />
        </Box>
        <Skeleton variant="text" width="90%" backgroundColor="light" />
        <Skeleton variant="text" width="60%" backgroundColor="light" />
        <Box marginTop="small">
          <Skeleton
            variant="rectangular"
            width={160}
            height={32}
            backgroundColor="light"
          />
        </Box>
      </Box>
    </Box>
    <Box marginLeft="xlarge" marginRight="xlarge">
      <Divider />
    </Box>
  </Box>
);
